import { atom } from 'jotai';

export enum AuthenticationState {
    SessionExpired = 'SessionExpired',
    NotLoggedIn = 'NotLoggedIn',
    LoggedOut = 'LoggedOut',
}

export const authenticationStateAtom = atom<AuthenticationState | undefined>(undefined);
export const redirectAfterLoginAtom = atom<string | undefined>(undefined);
